/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Group_Governance_PrivacyInputs */



/**
* | output |
* | --- |
* | "Governance & privacy" |
*
* @param {Onboarding_Usage_Group_Governance_PrivacyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_group_governance_privacy = /** @type {((inputs?: Onboarding_Usage_Group_Governance_PrivacyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Group_Governance_PrivacyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Governance & Datenschutz")
	return /** @type {LocalizedString} */ ("Governance & privacy")
});